module.exports = __webpack_public_path__ + "img/card-avatar.b3a8ba9c.png";